import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgFlight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    stroke="#4D4D4D"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.291 8.338 5.076 9.696s-.588.458-1.697.23c-1.109-.23-2.246-.48-2.246-.48s-.244-.09-.412.129c-.168.217.108.347.108.347l1.71 1.239s.366.361.903.266c.537-.095 2.117-.415 2.117-.415s1.078-.23 2.36-1.03c1.282-.8 5.866-3.582 5.866-3.582s1.784-1.013 1.605-1.438c-.179-.424-1.207-.31-1.7-.155-.49.155-4.329 2.33-4.329 2.33L5.155 5.695s-.544-.129-.272.189c.272.317 2.937 2.97 2.937 2.97m1.043 1.509 1.143 1.14s.331.262.398-.653.135-1.6.135-1.6" />
  </svg>
);
const Memo = memo(SvgFlight);
export default Memo;
